import moment from 'moment';

import {
  CANONICAL_FORMAT,
  DATETIME_FORMATS,
  USER_EDIT_DATE_FORMAT,
  USER_EDIT_DATETIME_FORMAT,
} from 'util/DateConstants';
import {getLocaleInputFormats} from 'util/DateUtil';
import lruMemoize from 'util/lruMemoize';
import {Optional} from 'util/Types';

function _tryParseAsMoment(text: string, languageTag?: Optional<string>): moment.Moment | null {
  const parsed = moment(
    text.trim(),
    [...getLocaleInputFormats(/* includeTime */ true, languageTag, true), ...DATETIME_FORMATS],
    /* strict */ true
  );
  return parsed.isValid() ? parsed : null;
}

export const tryParseAsMoment = lruMemoize(
  _tryParseAsMoment,
  {max: 2000},
  (text: string, languageTag?: Optional<string>) => `${text};${languageTag}`
);

function _tryParse(text: string, languageTag?: Optional<string>): string | null {
  const parsed = _tryParseAsMoment(text, languageTag);
  return parsed ? parsed.format(CANONICAL_FORMAT) : null;
}

export const tryParse = lruMemoize(
  _tryParse,
  {max: 2000},
  (text: string, languageTag?: Optional<string>) => `${text};${languageTag}`
);

/**
 * @param {string} text: Representation of date-time value
 * @param {string} languageTag: Locale for date-time string value
 * @returns String representation for date value (with time value stripped)
 */
function _tryParseDatetimeAsDate(text: string, languageTag?: Optional<string>): string | null {
  const parsed = _tryParseAsMoment(text, languageTag);
  return parsed ? parsed.format(USER_EDIT_DATE_FORMAT) : null;
}

export const tryParseDatetimeAsDate = lruMemoize(
  _tryParseDatetimeAsDate,
  {max: 2000},
  (text: string, languageTag?: Optional<string>) => `${text};${languageTag}`
);

export function now(): string {
  return moment().format(USER_EDIT_DATETIME_FORMAT);
}
